import React from "react"
import styled from "styled-components"
import { textButton } from "../Styles/TextStyles"

export default function Footer() {
  return (
    <Wrapper>
      <Column1>
        <Text>Hello</Text>
      </Column1>
      <Column1>
        <Text>Hello</Text>
      </Column1>
      <Column1>
        <Text>Hello</Text>
      </Column1>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  align-content: center;
  align-self: center;
  height: 500px;
  z-index: 1;
`

const Column1 = styled.div``

const Text = styled(textButton)`
  text-align: center;
`
